// Generated by CoffeeScript 2.7.0
var UserItem;

export default UserItem = Vue.extend({
  props: {
    user: Object,
    customClass: String,
    size: {
      type: String
    },
    vertical: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  template: `<div class="user-item" :class='classObj'>
  <template v-if='vertical'>
    <div class='remove-wrapper'>
      <i v-if='removable' class='slp-times-circle remove-icon' @click.stop='removeFunc'></i>
      <headimg :src="user.headimgurl" />
      </div>
    <span class="name">{{ user.name }}</span>
  </template>
  <template v-else>
    <headimg :src="user.headimgurl" />
    <div class='remove-wrapper'>
      <i v-if='removable' class='slp-times-circle remove-icon' @click.stop='removeFunc'></i>
      <span class="name">{{ user.name }}</span>
    </div>
  </template>
</div>`,
  data: function() {
    return {
      classObj: [
        this.customClass,
        this.size,
        {
          vertical: this.vertical
        }
      ]
    };
  },
  methods: {
    removeFunc: function() {
      return this.$emit('removed', this.user);
    }
  }
});
